var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('play-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.playing),expression:"!playing"}],staticClass:"play"}),_vm._v(" "),_c('video',{ref:"video",attrs:{"src":_vm.src,"controls":false,"width":"100%"},on:{"play":function($event){_vm.playing = true},"pause":function($event){_vm.playing = false},"ended":function($event){_vm.playing = false},"click":_vm.onClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6fbf02a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-player.vue
// module id = 279
// module chunks = 1